import { useRef } from "react"
import { motion, useScroll, useTransform } from 'framer-motion'

import Image from 'next/image'

import { Button } from '../../../components/button/button'
import { HeaderShim } from '../../../global/header/header'

import CSS from './page-header.module.css'

export const PageHeader = () => {

    let ref = useRef(null)
    
    let  scroll  = useScroll({
        target: ref,
        offset: ['start start', 'end start']
    })
    let y = useTransform( scroll.scrollYProgress, [0, 1], ["0%", "30%"])

    return (
        <>
            {/* <HeaderShim/> */}

            <section ref={ref} className={CSS.layout}>

                <div className={`${CSS.headline} formatted bg-secondary px-lg py-lg`}>
                    <p className='fs-2 fw-300 lh-1 caps'>IDEEA Sustainability Commitment</p>
                    <p className='fs-0 fw-600 lh-1 mt-sm'>Environmental, social, and governance (ESG)</p>
                </div>

                <div className={CSS.hero}>
                    <motion.div className={CSS.heroWrapper} style={{ y }}>
                        <Image src={`/assets/theme/esg.png`} width={800} height={850} layout={`responsive`} />
                    </motion.div>
                </div>

            </section>

        </>
    )
}